import { Response } from './../../../models/response.model';
import { BaseService } from './../../../services/base/base.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Home } from './../../../models/home.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-type-option',
  templateUrl: './product-type-option.component.html',
  styleUrls: ['./product-type-option.component.scss']
})
export class ProductTypeOptionComponent implements OnInit {
  storageUrl = environment.BASE_STORAGE_URL;

  data: Home = new Home();

  dataSubscription: Subscription;

  constructor(
    private baseService: BaseService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataSubscription = this.baseService.getAllNoHeader('home').subscribe((res: Response<Home>) => {
      if (res.retorno) {
        this.data = res.data;
      }
    });
  }
}
